
import React from 'react';
import MainLayout from '@/components/Layout/MainLayout';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <MainLayout>
      {/* Hero Section */}
      <section className="bg-forti-fi-background py-16 px-4" aria-labelledby="terms-hero-heading">
        <div className="container mx-auto max-w-4xl">
          <h1 id="terms-hero-heading" className="text-forti-fi mb-6 text-center">Terms of Service</h1>
          <div className="flex items-center justify-center mb-8 text-forti-fi">
            <FileText className="h-10 w-10 mr-3" />
            <p className="text-xl font-serif">Clear agreements for mutual success</p>
          </div>
        </div>
      </section>
      
      {/* Main Content */}
      <section className="py-12 px-4">
        <div className="container mx-auto max-w-3xl">
          <div className="prose prose-lg prose-stone mx-auto">
            <p className="text-lg mb-6">Last Updated: {new Date().toLocaleDateString('en-CA')}</p>
            
            <h2 className="text-forti-fi">1. Acceptance of Terms</h2>
            <p>
              These Terms of Service ("Terms") govern your access to and use of the website, products, and services ("Services") provided by Forti-Fi ("we," "our," or "us"). By accessing or using our Services, you agree to be bound by these Terms and our Privacy Policy.
            </p>
            <p>
              If you do not agree to these Terms, you may not access or use the Services. We may modify these Terms at any time by posting the updated Terms on our website, with the changes effective upon posting.
            </p>
            
            <h2 className="text-forti-fi">2. Use of Services</h2>
            <p>
              You agree to use the Services only for purposes that are legal, proper, and in accordance with these Terms and any applicable laws or regulations in Ontario, Canada. You shall not use the Services in any manner that could damage, disable, overburden, or impair our servers or networks, or interfere with any other party's use and enjoyment of the Services.
            </p>
            
            <h2 className="text-forti-fi">3. Intellectual Property Rights</h2>
            <p>
              All content, features, and functionality of the Services, including but not limited to text, graphics, logos, icons, images, audio clips, digital downloads, data compilations, and software, are the exclusive property of Forti-Fi, its licensors, or other content suppliers and are protected by Canadian and international intellectual property laws.
            </p>
            <p>
              You are granted a limited, non-exclusive, non-transferable, and revocable license to access and use the Services for your personal or internal business purposes. This license does not include the right to:
            </p>
            <ul>
              <li>Modify, reproduce, or create derivative works based on the Services</li>
              <li>Use any data mining, robots, or similar data gathering methods</li>
              <li>Download or copy any account information for the benefit of another party</li>
              <li>Use any meta tags or hidden text utilizing Forti-Fi's name or trademarks</li>
            </ul>
            
            <h2 className="text-forti-fi">4. Client Confidentiality</h2>
            <p>
              Forti-Fi maintains strict confidentiality standards in all client engagements. We will not disclose the nature of our work with clients without express written permission. This confidentiality extends to the identity of our clients, the scope of work performed, and any information provided during the course of our services.
            </p>
            
            <h2 className="text-forti-fi">5. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Forti-Fi, its directors, employees, partners, agents, suppliers, or affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, use, goodwill, or other intangible losses, resulting from:
            </p>
            <ul>
              <li>Your access to or use of or inability to access or use the Services</li>
              <li>Any conduct or content of any third party on the Services</li>
              <li>Unauthorized access, use, or alteration of your transmissions or content</li>
              <li>Any information or service obtained through the Services</li>
              <li>Any transactions entered into through the Services</li>
            </ul>
            <p>
              This limitation applies regardless of whether the damages are based on warranty, contract, tort, negligence, strict liability, or any other legal theory, and whether or not we have been advised of the possibility of such damages.
            </p>
            
            <h2 className="text-forti-fi">6. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless Forti-Fi, its officers, directors, employees, and agents, from and against any claims, liabilities, damages, losses, and expenses, including reasonable legal and accounting fees, arising out of or in any way connected with your access to or use of the Services or your violation of these Terms.
            </p>
            
            <h2 className="text-forti-fi">7. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the Province of Ontario and the federal laws of Canada applicable therein, without regard to conflict of law principles. You agree to submit to the personal and exclusive jurisdiction of the courts located within Ontario, Canada.
            </p>
            
            <h2 className="text-forti-fi">8. Dispute Resolution</h2>
            <p>
              Any dispute arising from or relating to these Terms or the Services shall first be attempted to be resolved through good faith negotiations. If such negotiations are unsuccessful, both parties agree to resolve the dispute through binding arbitration in Ontario, Canada, in accordance with the Arbitration Act (Ontario).
            </p>
            
            <h2 className="text-forti-fi">9. Severability</h2>
            <p>
              If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that the Terms will otherwise remain in full force and effect and enforceable.
            </p>
            
            <h2 className="text-forti-fi">10. Entire Agreement</h2>
            <p>
              These Terms, together with our Privacy Policy, constitute the entire agreement between you and Forti-Fi regarding the Services and supersede all prior and contemporaneous agreements, proposals, or representations, written or oral, concerning the subject matter.
            </p>
            
            <h2 className="text-forti-fi">11. Contact Information</h2>
            <p>
              For any questions about these Terms, please contact us at:
            </p>
            <div className="my-4">
              <p className="mb-1"><strong>Email:</strong> legal@forti-fi.ca</p>
              <p className="mb-1"><strong>Address:</strong> Forti-Fi, Ontario, Canada</p>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <Button asChild variant="gradient" className="text-white">
              <Link to="/contact">Contact Our Legal Team</Link>
            </Button>
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default TermsOfService;
